export default (doc) => {

    let url = '/'

    switch (doc.type) {
        case 'home_page':
            url = '/'
            break
        case 'city':
            url = '/cities/' + doc.uid
            break
        case 'category':
            url = '/playbook/' + doc.uid
            break
        case 'article':
            url = '/' + doc.uid
            break
        case 'foot':
            url = '/'
            break
        case 'onlinesto':
            url = '/shop'
            break
        case 'product':
            url = '/shop/' + doc.uid
            break
        case 'store':
            url = '/store/' + doc.uid
            break
        default:
            url = '/'
            break
    }

    return url
}
